import React, {useEffect, useState} from "react";
import {StyleSheet, View, TouchableOpacity} from "react-native";
import {Image, Text} from "native-base";
import apps from "./lib/apps";
import {PALETTE} from "./lib/palette";
import safeStorage from "./lib/storage";
import {loadLastOrder, LastOrder} from "./lib/lastOrder";
import {usePauseIdleGuard} from "./state/idleState";

function Thankyou({navigation}) {
    const accent = apps.getAccent();
    const onAccent = apps.onAccent();
    const [last, setLast] = useState<LastOrder | null>(null);
    usePauseIdleGuard();   // 종료 화면 — 무활동 초기화 정지

    useEffect(() => {
        // Replace the current URL
        window.history.replaceState({}, '', '.');
        // View Order용으로 완료 스냅샷을 먼저 읽어둔다(마커는 지우지 않음 — 재주문 가드/다시보기용).
        const uuid = safeStorage.getItem("uuid") ?? "";
        setLast(loadLastOrder(uuid));
        // Clear session data properly
        apps.ordIdClear();
        apps.ordNoClear();
    }, []);

    return (
        <View style={styles.container}>
            <View style={styles.card}>
                <View style={[styles.checkCircle, { backgroundColor: accent, shadowColor: accent }]}>
                    <Text style={[styles.check, { color: onAccent }]}>✓</Text>
                </View>

                <Text style={styles.title}>Thank You!</Text>
                <Text style={styles.subtitle}>
                    {last
                        ? "Your order has been placed.\nWe're getting it ready."
                        : "Your session has expired.\nPlease scan the table QR code again."}
                </Text>

                {last && (
                    <TouchableOpacity
                        style={[styles.viewOrderBtn, { backgroundColor: accent, shadowColor: accent }]}
                        activeOpacity={0.85}
                        onPress={() => navigation.navigate("OrderReview", {shopId: last.shopId, orderId: last.orderId})}>
                        <Text style={[styles.viewOrderText, { color: onAccent }]}>View Order</Text>
                    </TouchableOpacity>
                )}

                {last && (
                    <Text style={styles.hint}>To order again, scan the table QR code.</Text>
                )}
            </View>

            <Image style={styles.medianara} resizeMode="contain" alt="pikashop by medianara" source={require("../assets/pikashopbymedianara.png")}/>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: PALETTE.BG,
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
    },
    card: {
        width: "100%",
        maxWidth: 420,
        backgroundColor: "#fff",
        borderRadius: 24,
        paddingVertical: 40,
        paddingHorizontal: 28,
        alignItems: "center",
        borderWidth: 1,
        borderColor: PALETTE.BORDER,
        shadowColor: "#1c2230",
        shadowOpacity: 0.12,
        shadowRadius: 24,
        shadowOffset: {width: 0, height: 12},
        elevation: 4,
    },
    checkCircle: {
        width: 84,
        height: 84,
        borderRadius: PALETTE.RADIUS_PILL,
        backgroundColor: PALETTE.ACCENT,
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 22,
        shadowColor: PALETTE.ACCENT,
        shadowOpacity: 0.4,
        shadowRadius: 16,
        shadowOffset: {width: 0, height: 8},
    },
    check: {
        color: "#fff",
        fontSize: 46,
        fontWeight: "900",
        lineHeight: 52,
    },
    title: {
        fontSize: 28,
        fontWeight: "900",
        color: PALETTE.TEXT,
        marginBottom: 10,
        letterSpacing: -0.5,
    },
    subtitle: {
        fontSize: 16,
        color: PALETTE.MUTED,
        textAlign: "center",
        lineHeight: 23,
        marginBottom: 8,
    },
    viewOrderBtn: {
        marginTop: 22,
        width: "100%",
        maxWidth: 280,
        paddingVertical: 15,
        borderRadius: PALETTE.RADIUS_MD,
        backgroundColor: PALETTE.ACCENT,
        alignItems: "center",
        shadowColor: PALETTE.ACCENT,
        shadowOpacity: 0.45,
        shadowRadius: 18,
        shadowOffset: {width: 0, height: 10},
    },
    viewOrderText: {
        color: "#fff",
        fontSize: 17,
        fontWeight: "900",
        letterSpacing: -0.3,
    },
    hint: {
        marginTop: 16,
        fontSize: 13,
        color: PALETTE.MUTED,
        fontWeight: "700",
        textAlign: "center",
    },
    medianara: {
        width: 190,
        height: 14,
        marginTop: 36,
        opacity: 0.85,
    },
});

export default Thankyou;
